import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { sendCommandFlex8 } from "../../../API/AcionamentoFlex8";
import { getLuzesStatusFlex35, statusDasLuzesFlex35, getLuzesStatusFlex8, statusDasLuzesFlex8} from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo05: React.createRef(),
    grupo06: React.createRef(),
    grupo11: React.createRef(),
    grupo33: React.createRef(),
    grupo34: React.createRef(),
    grupo35: React.createRef(),
    grupo36: React.createRef(),
    grupo37: React.createRef(),
    grupo39: React.createRef(),
    grupo40: React.createRef(),
    grupo41: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo05: false,
    grupo06: false,
    grupo11: false,
    grupo33: false,
    grupo34: false,
    grupo35: false,
    grupo36: false,
    grupo37: false,
    grupo39: false,
    grupo40: false,
    grupo41: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      await getLuzesStatusFlex8();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes Flex35:", statusDasLuzesFlex35);
      console.log("Status das luzes Flex8:", statusDasLuzesFlex8);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8200);
  
    return () => clearInterval(intervalId);
  }, []);


  const updateLightGroup = () => {
    setImageStates({
      grupo05: statusDasLuzesFlex35.includes("1E10") && !statusDasLuzesFlex35.includes("1E00"),
      grupo06: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo11: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo33: statusDasLuzesFlex35.includes("1g10") && !statusDasLuzesFlex35.includes("1g00"),
      grupo34: statusDasLuzesFlex35.includes("1h10") && !statusDasLuzesFlex35.includes("1h00"),
      grupo35: statusDasLuzesFlex35.includes("1i10") && !statusDasLuzesFlex35.includes("1i00"),
      grupo36: statusDasLuzesFlex8[0] && statusDasLuzesFlex8[0].includes("ON"),
      grupo37: statusDasLuzesFlex8[1] && statusDasLuzesFlex8[1].includes("ON"),
      grupo39: statusDasLuzesFlex8[3] && statusDasLuzesFlex8[3].includes("ON"),
      grupo40: statusDasLuzesFlex8[4] && statusDasLuzesFlex8[4].includes("ON"),
      grupo41: statusDasLuzesFlex8[5] &&  statusDasLuzesFlex8[5].includes("ON"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };
  
  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return null;
  }

  return (
    <div id="BotoesMobile">
      <h2 id='Title-botoes-Mobile'>Intermediário</h2>
      <div className="campoBotoesAcionamento-mobile">
        <h3 id='Topic-botoes-Mobile'>San Marino</h3>
        <div
          ref={groupRefs.current.grupo05}
          id="clickable-element-mobile-san-marino"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo05', !imageStates.grupo05);
            sendCommandFlex35('Circulação Intermediário da torre San Marino', imageStates.grupo05 ? '1E00' : '1E10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo05 ? 'Highlighted' : ''}`}>05</p>
          <p className="textBar">Circulação Intermediário</p>
        </div>

        <div
          ref={groupRefs.current.grupo06}
          id="clickable-element-mobile-san-marino"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo06', !imageStates.grupo06);
            sendCommandFlex35('Circulação Varanda da torre San Marino', imageStates.grupo06 ? '1F00' : '1F10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo06 ? 'Highlighted' : ''}`}>06</p>
          <p className="textBar">Circulação Varanda</p>
        </div>

        <h3 id='Topic-botoes-Mobile'>Positano</h3>

        <div
          ref={groupRefs.current.grupo11}
          id="clickable-element-mobile-positano"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo11', !imageStates.grupo11);
            sendCommandFlex35('Circulação Intermediária da Torre Positano', imageStates.grupo11 ? '1K00' : '1K10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo11 ? 'Highlighted' : ''}`}>11</p>
          <p className="textBar">Circulação Intermediária</p>
        </div>

        <h3 id='Topic-botoes-Mobile'>Outros</h3>

        <div
          ref={groupRefs.current.grupo33}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo33', !imageStates.grupo33);
            sendCommandFlex35('Jardim Fundos 1', imageStates.grupo33 ? '1a00' : '1a10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo33 ? 'Highlighted' : ''}`}>33</p>
          <p className="textBar">Jardim Fundos 1</p>
        </div>

        <div
          ref={groupRefs.current.grupo34}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo34', !imageStates.grupo34);
            sendCommandFlex35('Jardim Fundos 2', imageStates.grupo34 ? '1b00' : '1b10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo34 ? 'Highlighted' : ''}`}>34</p>
          <p className="textBar">Jardim Fundos 2</p>
        </div>

        <div
          ref={groupRefs.current.grupo35}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo35', !imageStates.grupo35);
            sendCommandFlex35('Escadarias Fundos', imageStates.grupo35 ? '1c00' : '1c10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo35 ? 'Highlighted' : ''}`}>35</p>
          <p className="textBar">Escadarias Fundos</p>
        </div>

        <div
          ref={groupRefs.current.grupo36}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo36', !imageStates.grupo36);
            sendCommandFlex8('Garden Gourmet 1', imageStates.grupo36 ? {idx: "1", status: "OFF"} : {idx: "1", status: "ON"});
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo36 ? 'Highlighted' : ''}`}>36</p>
          <p className="textBar">Garden Gourmet 1</p>
        </div>

        <div
          ref={groupRefs.current.grupo37}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo37', !imageStates.grupo37);
            sendCommandFlex8('Garden Gourmet 2', imageStates.grupo37 ? {idx: "2", status: "OFF"} : {idx: "2", status: "ON"});
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo37 ? 'Highlighted' : ''}`}>37</p>
          <p className="textBar">Garden Gourmet 2</p>
        </div>

        <div
          ref={groupRefs.current.grupo39}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo39', !imageStates.grupo39);
            sendCommandFlex8('Piscina Garden', imageStates.grupo39 ? {idx: "4", status: "OFF"} : {idx: "4", status: "ON"});
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo39 ? 'Highlighted' : ''}`}>39</p>
          <p className="textBar">Piscina Garden</p>
        </div>

        <div
          ref={groupRefs.current.grupo40}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo40', !imageStates.grupo40);
            sendCommandFlex8('Poste Fundos 1', imageStates.grupo40 ? {idx: "5", status: "OFF"} : {idx: "5", status: "ON"});
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo40 ? 'Highlighted' : ''}`}>40</p>
          <p className="textBar">Poste Fundos 1</p>
        </div>

        <div
          ref={groupRefs.current.grupo41}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo41', !imageStates.grupo41);
            sendCommandFlex8('Poste Fundos 2', imageStates.grupo41 ? {idx: "6", status: "OFF"} : {idx: "6", status: "ON"});
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo41 ? 'Highlighted' : ''}`}>41</p>
          <p className="textBar">Poste Fundos 2</p>
        </div>
      </div>
    </div>
  );
}

export default BotoesMobile;